const ACCESS_MGMT_MQ_DASHBOARD = 'access-management-marqeta-dashboard';
const ACCESS_MGMT_MQ_DASHBOARD_VIEW = 'access-management-marqeta-dashboard-view';
const ACCESS_MGMT_MQ_DASHBOARD_VIEW_AND_EDIT = 'access-management-marqeta-dashboard-view-and-edit';

const ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL = 'access-management-marqeta-dashboard-external';
const ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW = 'access-management-marqeta-dashboard-external-view';
const ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW_AND_EDIT =
  'access-management-marqeta-dashboard-external-view-and-edit';

const ACCOUNT_HOLDER_DETAILS = 'account-holder-details';
const ACCOUNT_HOLDER_DETAILS_VIEW = 'account-holder-details-view';
const ACCOUNT_HOLDER_DETAILS_VIEW_AND_EDIT = 'account-holder-details-view-and-edit';

const ACCOUNT_HOLDER_DETAILS_SENSITIVE = 'account-holder-details-sensitive';
const ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW = 'account-holder-details-sensitive-view';
const ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW_AND_EDIT =
  'account-holder-details-sensitive-view-and-edit';

const AUDIT_LOGS = 'audit-logs';
const AUDIT_LOGS_VIEW = 'audit-logs-view';

const BIN_DATA_MANAGEMENT = 'bin-data-management';
const BIN_DATA_MANAGEMENT_VIEW = 'bin-data-management-view';
const BIN_DATA_MANAGEMENT_VIEW_AND_EDIT = 'bin-data-management-view-and-edit';

const BUSINESS_DETAILS = 'business-details';
const BUSINESS_DETAILS_VIEW = 'business-details-view';
const BUSINESS_DETAILS_VIEW_AND_EDIT = 'business-details-view-and-edit';

const CANCEL_ACHO_PROGRAM_FUNDING = 'cancel-acho-program-funding';
const CANCEL_ACHO_PROGRAM_FUNDING_VIEW_AND_EDIT = `${CANCEL_ACHO_PROGRAM_FUNDING}-view-and-edit`;

const MANAGE_ACHO_TRANSFERS = 'manage-acho-transfers';
const MANAGE_ACHO_TRANSFERS_VIEW_AND_EDIT = 'manage-acho-transfers-view-and-edit';

const CARD_DETAILS = 'card-details';
const CARD_DETAILS_VIEW = 'card-details-view';
const CARD_DETAILS_VIEW_AND_EDIT = 'card-details-view-and-edit';

const CARD_PRODUCTS = 'card-products';
const CARD_PRODUCTS_VIEW = 'card-products-view';

const CREATE_CARD_MANUALLY = 'create-card-manually';
const CREATE_CARD_MANUALLY_VIEW_AND_EDIT = 'create-card-manually-view-and-edit';

const FULL_ACCOUNT_NUMBER = 'full-account-number';
const FULL_ACCOUNT_NUMBER_VIEW = `${FULL_ACCOUNT_NUMBER}-view`;

const FULL_PAN = 'full-pan';
const FULL_PAN_VIEW = `${FULL_PAN}-view`;

const INVENTORY_MGMT = 'inventory-management';
const INVENTORY_MGMT_VIEW = 'inventory-management-view';

const INVOKE_COMMANDO_MODE = 'invoke-commando-mode';
const INVOKE_COMMANDO_MODE_VIEW = 'invoke-commando-mode-view';
const INVOKE_COMMANDO_MODE_VIEW_AND_EDIT = 'invoke-commando-mode-view-and-edit';
const DISPUTES = 'disputes';
const DISPUTES_VIEW_AND_EDIT = 'disputes-view-and-edit';
const PROCESS_DISPUTES = 'process-disputes';
const PROCESS_DISPUTES_VIEW_AND_EDIT = 'process-disputes-view-and-edit';

const KYC_EXCEPTIONS = 'kyc-exceptions';
const KYC_EXCEPTIONS_VIEW_AND_EDIT = 'kyc-exceptions-view-and-edit';

const MANAGE_TRANSACTION_ALERTS = 'manage-transaction-alerts';
const MANAGE_TRANSACTION_ALERTS_VIEW_AND_EDIT = 'manage-transaction-alerts-view-and-edit';

const THREE_DS_SETTINGS = '3ds-settings';
const THREE_DS_SETTINGS_VIEW = '3ds-settings-view';
const THREE_DS_SETTINGS_VIEW_AND_EDIT = '3ds-settings-view-and-edit';

const TRANSACTION_REVIEW_REPORT = 'transaction-review-report';
const TRANSACTION_REVIEW_REPORT_VIEW = 'transaction-review-report-view';

const UAM_GRANULAR_PERMISSIONS = 'uam-granular-permissions';

const USER_DETAILS = 'user-details';
const USER_DETAILS_VIEW = 'user-details-view';
const USER_DETAILS_VIEW_AND_EDIT = 'user-details-view-and-edit';

const USER_DETAILS_SENSITIVE = 'user-details-sensitive';
const USER_DETAILS_SENSITIVE_VIEW = 'user-details-sensitive-view';
// User Details senstitive - view & edit has been deprecated (SPD-1859)
const USER_DETAILS_SENSITIVE_VIEW_AND_EDIT = 'user-details-sensitive-view-and-edit';

const PROGRAM_CONFIGURATION = 'program-configuration';
const PROGRAM_CONFIGURATION_VIEW_AND_EDIT = 'program-configuration-view-and-edit';

const ACH_PROGRAM_FUNDING = 'ach-program-funding';
const ACH_PROGRAM_FUNDING_VIEW = 'ach-program-funding-view';
const ACH_PROGRAM_FUNDING_VIEW_AND_EDIT = 'ach-program-funding-view-and-edit';

const REAL_TIME_DECISIONING = 'real-time-decisioning';
const REAL_TIME_DECISIONING_VIEW_AND_EDIT = 'real-time-decisioning-view-and-edit';

const REPLACE_CARD = 'replace-card';
const REPLACE_CARD_VIEW_AND_EDIT = 'replace-card-view-and-edit';

const REPORT_STOLEN = 'report-stolen';
const REPORT_STOLEN_VIEW_AND_EDIT = 'report-stolen-view-and-edit';

const RETURN_DIRECT_DEPOSIT = 'return-direct-deposit';
const RETURN_DIRECT_DEPOSIT_VIEW_AND_EDIT = 'return-direct-deposit-view-and-edit';

const SET_PIN = 'set-pin';
const SET_PIN_VIEW_AND_EDIT = 'set-pin-view-and-edit';

const SUSPEND_CARD = 'suspend-card';
const SUSPEND_CARD_VIEW_AND_EDIT = 'suspend-card-view-and-edit';

const DIGITAL_WALLET_TOKEN_DETAILS = 'digital-wallet-token-details';
const DIGITAL_WALLET_TOKEN_DETAILS_VIEW = 'digital-wallet-token-details-view';
const DIGITAL_WALLET_TOKEN_DETAILS_VIEW_AND_EDIT = 'digital-wallet-token-details-view-and-edit';

const PRIVATE_SANDBOX = 'private-sandbox';

const ISSUER_WRITE_OFF = 'issuer-write-off';
const ISSUER_WRITE_OFF_VIEW_AND_EDIT = 'issuer-write-off-view-and-edit';

const CUSTOMER_SUPPORT_SWISSQUOTE = 'customer-support-swissquote';
const CUSTOMER_SUPPORT_YUH = 'customer-support-yuh';

const REMOVE_CARDHOLDER_FUNDS = 'remove-cardholder-funds';
const REMOVE_CARDHOLDER_FUNDS_VIEW_AND_EDIT = 'remove-cardholder-funds-view-and-edit';

const DISPUTES_MANUAL_TRANSITIONS = 'disputes-manual-transitions';
const DISPUTES_MANUAL_TRANSITIONS_VIEW_AND_EDIT = 'disputes-manual-transitions-view-and-edit';

// credit related permissions
const CREDIT_ACCOUNT_HOLDER_DETAILS = 'credit-account-holder-details';
const CREDIT_ACCOUNT_HOLDER_DETAILS_VIEW = 'credit-account-holder-details-view';
const CREDIT_ACCOUNT_PAYMENT_SCHEDULE = 'credit-account-payment-schedule';
const CREDIT_ACCOUNT_PAYMENT_SCHEDULE_VIEW = 'credit-account-payment-schedule-view';
const CREDIT_ACCOUNT_PAYMENT_SOURCE = 'credit-account-payment-source';
const CREDIT_ACCOUNT_PAYMENT_SOURCE_VIEW = 'credit-account-payment-source-view';
const CREDIT_ACCOUNT_TRANSACTIONS = 'credit-account-transactions';
const CREDIT_ACCOUNT_TRANSACTIONS_VIEW = 'credit-account-transactions-view';
const CREDIT_ACCOUNT_TRANSACTIONS_VIEW_AND_EDIT = 'credit-account-transactions-view-and-edit';
const CREDIT_ACCOUNT_NOTES = 'credit-account-notes';
const CREDIT_ACCOUNT_NOTES_VIEW = 'credit-account-notes-view';
const CREDIT_ACCOUNT_NOTES_VIEW_AND_EDIT = 'credit-account-notes-view-and-edit';
const CREDIT_ACCOUNT_STATEMENTS = 'credit-account-statements';
const CREDIT_ACCOUNT_STATEMENTS_VIEW = 'credit-account-statements-view';
const CREDIT_ACCOUNT_SUBSTATUS = 'credit-account-substatus';
const CREDIT_ACCOUNT_SUBSTATUS_VIEW = 'credit-account-substatus-view';
const CREDIT_ACCOUNT_SUBSTATUS_VIEW_AND_EDIT = 'credit-account-substatus-view-and-edit';


// ADD ALL VIEW AND VIEW-AND-EDIT ROLE TOKENS INTO THIS OBJECT.
// When adding/updating a user, removeInvalidRoles will be called and checks to make sure the role is in this hash otherwise it will remove the role and it won't be saved to redsea.
const UAM_ROLES = [
  ACCESS_MGMT_MQ_DASHBOARD_VIEW_AND_EDIT,
  ACCESS_MGMT_MQ_DASHBOARD_VIEW,
  ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW,
  ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW_AND_EDIT,
  ACCOUNT_HOLDER_DETAILS_VIEW,
  ACCOUNT_HOLDER_DETAILS_VIEW_AND_EDIT,
  ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW,
  ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW_AND_EDIT,
  ACH_PROGRAM_FUNDING_VIEW,
  ACH_PROGRAM_FUNDING_VIEW_AND_EDIT,
  AUDIT_LOGS_VIEW,
  BIN_DATA_MANAGEMENT_VIEW,
  BIN_DATA_MANAGEMENT_VIEW_AND_EDIT,
  BUSINESS_DETAILS_VIEW,
  BUSINESS_DETAILS_VIEW_AND_EDIT,
  MANAGE_ACHO_TRANSFERS,
  MANAGE_ACHO_TRANSFERS_VIEW_AND_EDIT,
  CANCEL_ACHO_PROGRAM_FUNDING_VIEW_AND_EDIT,
  CARD_DETAILS_VIEW_AND_EDIT,
  CARD_DETAILS_VIEW,
  CARD_PRODUCTS_VIEW,
  CREATE_CARD_MANUALLY_VIEW_AND_EDIT,
  CUSTOMER_SUPPORT_SWISSQUOTE,
  CUSTOMER_SUPPORT_YUH,
  DIGITAL_WALLET_TOKEN_DETAILS_VIEW,
  DIGITAL_WALLET_TOKEN_DETAILS_VIEW_AND_EDIT,
  DISPUTES_VIEW_AND_EDIT,
  PROCESS_DISPUTES_VIEW_AND_EDIT,
  FULL_ACCOUNT_NUMBER_VIEW,
  FULL_PAN_VIEW,
  INVENTORY_MGMT_VIEW,
  INVOKE_COMMANDO_MODE_VIEW,
  INVOKE_COMMANDO_MODE_VIEW_AND_EDIT,
  KYC_EXCEPTIONS_VIEW_AND_EDIT,
  MANAGE_TRANSACTION_ALERTS_VIEW_AND_EDIT,
  PRIVATE_SANDBOX,
  REAL_TIME_DECISIONING_VIEW_AND_EDIT,
  REPLACE_CARD_VIEW_AND_EDIT,
  REPORT_STOLEN_VIEW_AND_EDIT,
  RETURN_DIRECT_DEPOSIT_VIEW_AND_EDIT,
  PROGRAM_CONFIGURATION_VIEW_AND_EDIT,
  SET_PIN_VIEW_AND_EDIT,
  SUSPEND_CARD_VIEW_AND_EDIT,
  THREE_DS_SETTINGS_VIEW_AND_EDIT,
  THREE_DS_SETTINGS_VIEW,
  TRANSACTION_REVIEW_REPORT_VIEW,
  UAM_GRANULAR_PERMISSIONS,
  USER_DETAILS_SENSITIVE_VIEW,
  USER_DETAILS_VIEW_AND_EDIT,
  USER_DETAILS_VIEW,
  ISSUER_WRITE_OFF,
  ISSUER_WRITE_OFF_VIEW_AND_EDIT,
  REMOVE_CARDHOLDER_FUNDS_VIEW_AND_EDIT,
  DISPUTES_MANUAL_TRANSITIONS,
  DISPUTES_MANUAL_TRANSITIONS_VIEW_AND_EDIT,

  CREDIT_ACCOUNT_HOLDER_DETAILS_VIEW,
  CREDIT_ACCOUNT_PAYMENT_SCHEDULE_VIEW,
  CREDIT_ACCOUNT_PAYMENT_SOURCE_VIEW,
  CREDIT_ACCOUNT_TRANSACTIONS_VIEW,
  CREDIT_ACCOUNT_TRANSACTIONS_VIEW_AND_EDIT,
  CREDIT_ACCOUNT_NOTES_VIEW,
  CREDIT_ACCOUNT_NOTES_VIEW_AND_EDIT,
  CREDIT_ACCOUNT_STATEMENTS_VIEW,
  CREDIT_ACCOUNT_SUBSTATUS_VIEW,
  CREDIT_ACCOUNT_SUBSTATUS_VIEW_AND_EDIT
];

const EXTERNAL_DELEGATION_REQUIRED_ROLES = [
  PROCESS_DISPUTES_VIEW_AND_EDIT,
  REMOVE_CARDHOLDER_FUNDS_VIEW_AND_EDIT,
  USER_DETAILS_SENSITIVE_VIEW,
  USER_DETAILS_SENSITIVE_VIEW_AND_EDIT,
  SET_PIN_VIEW_AND_EDIT,
  FULL_PAN_VIEW,
];

const VIEW_AND_EDIT = 'view_and_edit';
const VIEW_ONLY = 'view_only';
const NO_ACCESS = 'no_access';

const CARD_MANAGEMENT = 'Card management';
const CREDIT = 'Credit';
const CONTROL_CENTER = 'Control center';
const CUSTOMERS = 'Customers';
const DIGITAL_WALLET = 'Digital wallet';
const PROGRAM_CONTROL = 'Program control';
const REPORT = 'Report';
const RISK_CONTROL = 'Risk control';

//This will convert the redsea role_token into a permissions object. For example, for the following role tokens =>
//'3ds-settings-view-and-edit' => {role_token: '3ds-settings', no_access: false, view_only: false, view_and_edit: true } will be the permission object
//'uam-granular-permissions' => {role_token: 'uam-granular-permissions', no_access: false, view_only: true, view_and_edit: false } will be the permission object
const redseaRoleTokenToPermissionsHash = {
  [THREE_DS_SETTINGS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: THREE_DS_SETTINGS,
    section: CONTROL_CENTER,
  },
  [THREE_DS_SETTINGS_VIEW]: {
    access: VIEW_ONLY,
    role_token: THREE_DS_SETTINGS,
    section: CONTROL_CENTER,
  },
  [ACCESS_MGMT_MQ_DASHBOARD_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: ACCESS_MGMT_MQ_DASHBOARD,
    section: CONTROL_CENTER,
  },
  [ACCESS_MGMT_MQ_DASHBOARD_VIEW]: {
    access: VIEW_ONLY,
    role_token: ACCESS_MGMT_MQ_DASHBOARD,
    section: CONTROL_CENTER,
  },
  [ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL,
    section: CONTROL_CENTER,
  },
  [ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW]: {
    access: VIEW_ONLY,
    role_token: ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL,
    section: CONTROL_CENTER,
  },
  [ACCOUNT_HOLDER_DETAILS_VIEW]: {
    access: VIEW_ONLY,
    role_token: ACCOUNT_HOLDER_DETAILS,
    section: CUSTOMERS,
  },
  [ACCOUNT_HOLDER_DETAILS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: ACCOUNT_HOLDER_DETAILS,
    section: CUSTOMERS,
  },
  [ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW]: {
    access: VIEW_ONLY,
    role_token: ACCOUNT_HOLDER_DETAILS_SENSITIVE,
    section: CUSTOMERS,
  },
  [ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: ACCOUNT_HOLDER_DETAILS_SENSITIVE,
    section: CUSTOMERS,
  },
  [AUDIT_LOGS_VIEW]: {
    access: VIEW_ONLY,
    role_token: AUDIT_LOGS,
    section: CONTROL_CENTER,
  },
  [BIN_DATA_MANAGEMENT_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: BIN_DATA_MANAGEMENT,
    section: PROGRAM_CONTROL,
  },
  [BIN_DATA_MANAGEMENT_VIEW]: {
    access: VIEW_ONLY,
    role_token: BIN_DATA_MANAGEMENT,
    section: PROGRAM_CONTROL,
  },
  [BUSINESS_DETAILS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: BUSINESS_DETAILS,
    section: CUSTOMERS,
  },
  [BUSINESS_DETAILS_VIEW]: {
    access: VIEW_ONLY,
    role_token: BUSINESS_DETAILS,
    section: CUSTOMERS,
  },
  [CANCEL_ACHO_PROGRAM_FUNDING_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: CANCEL_ACHO_PROGRAM_FUNDING,
    section: CUSTOMERS,
  },
  [CARD_DETAILS_VIEW]: {
    access: VIEW_ONLY,
    role_token: CARD_DETAILS,
    section: CARD_MANAGEMENT,
  },
  [CARD_DETAILS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: CARD_DETAILS,
    section: CARD_MANAGEMENT,
  },
  [CARD_PRODUCTS_VIEW]: {
    access: VIEW_ONLY,
    role_token: CARD_PRODUCTS,
    section: CARD_MANAGEMENT,
  },
  [CREATE_CARD_MANUALLY_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: CREATE_CARD_MANUALLY,
    section: CARD_MANAGEMENT,
  },
  [CUSTOMER_SUPPORT_SWISSQUOTE]: {
    access: VIEW_ONLY,
    role_token: CUSTOMER_SUPPORT_SWISSQUOTE,
    section: CUSTOMERS,
  },
  [CUSTOMER_SUPPORT_YUH]: {
    access: VIEW_ONLY,
    role_token: CUSTOMER_SUPPORT_YUH,
    section: CUSTOMERS,
  },
  [DIGITAL_WALLET_TOKEN_DETAILS_VIEW]: {
    access: VIEW_ONLY,
    role_token: DIGITAL_WALLET_TOKEN_DETAILS,
    section: DIGITAL_WALLET,
  },
  [DIGITAL_WALLET_TOKEN_DETAILS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: DIGITAL_WALLET_TOKEN_DETAILS,
    section: DIGITAL_WALLET,
  },
  [DISPUTES_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: DISPUTES,
    section: RISK_CONTROL,
  },
  [PROCESS_DISPUTES_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: PROCESS_DISPUTES,
    section: RISK_CONTROL,
  },
  [FULL_ACCOUNT_NUMBER_VIEW]: {
    access: VIEW_ONLY,
    role_token: FULL_ACCOUNT_NUMBER,
    section: CUSTOMERS,
  },
  [INVENTORY_MGMT_VIEW]: {
    access: VIEW_ONLY,
    role_token: INVENTORY_MGMT,
    section: PROGRAM_CONTROL,
  },
  [INVOKE_COMMANDO_MODE_VIEW]: {
    access: VIEW_ONLY,
    role_token: INVOKE_COMMANDO_MODE,
    section: CONTROL_CENTER,
  },
  [INVOKE_COMMANDO_MODE_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: INVOKE_COMMANDO_MODE,
    section: CONTROL_CENTER,
  },
  [KYC_EXCEPTIONS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: KYC_EXCEPTIONS,
    section: RISK_CONTROL,
  },
  [MANAGE_ACHO_TRANSFERS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: MANAGE_ACHO_TRANSFERS,
    section: CUSTOMERS,
  },
  [MANAGE_TRANSACTION_ALERTS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: MANAGE_TRANSACTION_ALERTS,
    section: RISK_CONTROL,
  },
  [UAM_GRANULAR_PERMISSIONS]: {
    access: VIEW_ONLY,
    role_token: UAM_GRANULAR_PERMISSIONS,
    section: PROGRAM_CONTROL,
  },
  [PRIVATE_SANDBOX]: {
    access: VIEW_ONLY,
    role_token: PRIVATE_SANDBOX,
    section: CONTROL_CENTER,
  },
  [PROGRAM_CONFIGURATION_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: PROGRAM_CONFIGURATION,
    section: PROGRAM_CONTROL,
  },
  [ACH_PROGRAM_FUNDING_VIEW]: {
    access: VIEW_ONLY,
    role_token: ACH_PROGRAM_FUNDING,
    section: CUSTOMERS,
  },
  [ACH_PROGRAM_FUNDING_VIEW_AND_EDIT]: {
    role_token: ACH_PROGRAM_FUNDING,
    access: VIEW_AND_EDIT,
    section: CUSTOMERS,
  },
  [USER_DETAILS_VIEW]: {
    access: VIEW_ONLY,
    role_token: USER_DETAILS,
    section: CUSTOMERS,
  },
  [USER_DETAILS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: USER_DETAILS,
    section: CUSTOMERS,
  },
  [USER_DETAILS_SENSITIVE_VIEW]: {
    access: VIEW_ONLY,
    role_token: USER_DETAILS_SENSITIVE,
    section: CUSTOMERS,
  },
  //User details sensitive view and edit has been deprecated. (SPD-1859)
  [USER_DETAILS_SENSITIVE_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: USER_DETAILS_SENSITIVE,
    section: CUSTOMERS,
  },
  [FULL_PAN_VIEW]: {
    access: VIEW_ONLY,
    role_token: FULL_PAN,
    section: CARD_MANAGEMENT,
  },
  [REAL_TIME_DECISIONING_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: REAL_TIME_DECISIONING,
    section: RISK_CONTROL,
  },
  [REPLACE_CARD_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: REPLACE_CARD,
    section: CARD_MANAGEMENT,
  },
  [REPORT_STOLEN_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: REPORT_STOLEN,
    section: CARD_MANAGEMENT,
  },
  [RETURN_DIRECT_DEPOSIT_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: RETURN_DIRECT_DEPOSIT,
    section: CUSTOMERS,
  },
  [SUSPEND_CARD_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: SUSPEND_CARD,
    section: CARD_MANAGEMENT,
  },
  [SET_PIN_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: SET_PIN,
    section: CARD_MANAGEMENT,
  },
  [TRANSACTION_REVIEW_REPORT_VIEW]: {
    access: VIEW_ONLY,
    role_token: TRANSACTION_REVIEW_REPORT,
    section: RISK_CONTROL,
  },
  [REMOVE_CARDHOLDER_FUNDS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: REMOVE_CARDHOLDER_FUNDS,
    section: CUSTOMERS,
  },
  [DISPUTES_MANUAL_TRANSITIONS_VIEW_AND_EDIT]: {
    role_token: DISPUTES_MANUAL_TRANSITIONS,
    access: VIEW_AND_EDIT,
    section: RISK_CONTROL,
  },
  //Credit related permissions
  [CREDIT_ACCOUNT_HOLDER_DETAILS_VIEW]: {
    access: VIEW_ONLY,
    role_token: CREDIT_ACCOUNT_HOLDER_DETAILS,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_PAYMENT_SCHEDULE_VIEW]: {
    access: VIEW_ONLY,
    role_token: CREDIT_ACCOUNT_PAYMENT_SCHEDULE,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_PAYMENT_SOURCE_VIEW]: {
    access: VIEW_ONLY,
    role_token: CREDIT_ACCOUNT_PAYMENT_SOURCE,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_STATEMENTS_VIEW]: {
    access: VIEW_ONLY,
    role_token: CREDIT_ACCOUNT_STATEMENTS,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_NOTES_VIEW]: {
    access: VIEW_ONLY,
    role_token: CREDIT_ACCOUNT_NOTES,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_NOTES_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: CREDIT_ACCOUNT_NOTES,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_SUBSTATUS_VIEW]: {
    access: VIEW_ONLY,
    role_token: CREDIT_ACCOUNT_SUBSTATUS,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_SUBSTATUS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: CREDIT_ACCOUNT_SUBSTATUS,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_TRANSACTIONS_VIEW]: {
    access: VIEW_ONLY,
    role_token: CREDIT_ACCOUNT_TRANSACTIONS,
    section: CREDIT,
  },
  [CREDIT_ACCOUNT_TRANSACTIONS_VIEW_AND_EDIT]: {
    access: VIEW_AND_EDIT,
    role_token: CREDIT_ACCOUNT_TRANSACTIONS,
    section: CREDIT,
  },
};

//This will convert the permission role token to a redsea token. For example, for the following permissions =>
//{role_token: '3ds-settings', no_access: false, view_only: true, view_and_edit: false } => '3ds-settings-view' will be the role_token stored in redsea
//{role_token: 'uam-granular-permissions', no_access: false, view_only: true, view_and_edit: false } => 'uam-granular-permissions' will be the role_token stored in redsea
const permissionsRoleTokenLabelAndRedseaHash = {
  [THREE_DS_SETTINGS]: {
    label: 'ThreeDS settings',
    section: CONTROL_CENTER,
    view_only: THREE_DS_SETTINGS_VIEW,
    view_and_edit: THREE_DS_SETTINGS_VIEW_AND_EDIT,
  },
  [ACCESS_MGMT_MQ_DASHBOARD]: {
    label: 'Access management - Marqeta Dashboard',
    section: CONTROL_CENTER,
    view_only: ACCESS_MGMT_MQ_DASHBOARD_VIEW,
    view_and_edit: ACCESS_MGMT_MQ_DASHBOARD_VIEW_AND_EDIT,
  },
  [ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL]: {
    label: 'Access management - Marqeta Dashboard (External)',
    section: CONTROL_CENTER,
    view_only: ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW,
    view_and_edit: ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW_AND_EDIT,
  },
  [ACCOUNT_HOLDER_DETAILS]: {
    label: 'Account holder details',
    section: CUSTOMERS,
    view_only: ACCOUNT_HOLDER_DETAILS_VIEW,
    view_and_edit: ACCOUNT_HOLDER_DETAILS_VIEW_AND_EDIT,
  },
  [ACCOUNT_HOLDER_DETAILS_SENSITIVE]: {
    label: 'Account holder details (sensitive)',
    section: CUSTOMERS,
    view_only: ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW,
    view_and_edit: ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW_AND_EDIT,
  },
  [AUDIT_LOGS]: {
    label: 'Audit logs',
    section: CONTROL_CENTER,
    view_only: AUDIT_LOGS_VIEW,
    view_and_edit: null,
  },
  [BIN_DATA_MANAGEMENT]: {
    label: 'BIN Data Management',
    section: PROGRAM_CONTROL,
    view_only: BIN_DATA_MANAGEMENT_VIEW,
    view_and_edit: BIN_DATA_MANAGEMENT_VIEW_AND_EDIT,
  },
  [BUSINESS_DETAILS]: {
    label: 'Business details',
    section: CUSTOMERS,
    view_only: BUSINESS_DETAILS_VIEW,
    view_and_edit: BUSINESS_DETAILS_VIEW_AND_EDIT,
  },
  [MANAGE_ACHO_TRANSFERS]: {
    label: 'Manage ACHO Transfers',
    section: CUSTOMERS,
    view_only: null,
    view_and_edit: MANAGE_ACHO_TRANSFERS_VIEW_AND_EDIT,
  },
  [CANCEL_ACHO_PROGRAM_FUNDING]: {
    label: 'Cancel ACHO program funding',
    section: CUSTOMERS,
    view_only: null,
    view_and_edit: CANCEL_ACHO_PROGRAM_FUNDING_VIEW_AND_EDIT,
  },
  [CARD_DETAILS]: {
    label: 'Card details',
    section: CARD_MANAGEMENT,
    view_only: CARD_DETAILS_VIEW,
    view_and_edit: CARD_DETAILS_VIEW_AND_EDIT,
  },
  [CARD_PRODUCTS]: {
    label: 'Card products',
    section: CARD_MANAGEMENT,
    view_only: CARD_PRODUCTS_VIEW,
    view_and_edit: null,
  },
  [CREATE_CARD_MANUALLY]: {
    label: 'Create card manually',
    section: CARD_MANAGEMENT,
    view_only: null,
    view_and_edit: CREATE_CARD_MANUALLY_VIEW_AND_EDIT,
  },
  [CUSTOMER_SUPPORT_SWISSQUOTE]: {
    label: 'Customer Support Swissquote',
    section: CUSTOMERS,
    view_only: CUSTOMER_SUPPORT_SWISSQUOTE,
    view_and_edit: null,
  },
  [CUSTOMER_SUPPORT_YUH]: {
    label: 'Customer Support YUH',
    section: CUSTOMERS,
    view_only: CUSTOMER_SUPPORT_YUH,
    view_and_edit: null,
  },
  [DIGITAL_WALLET_TOKEN_DETAILS]: {
    label: 'Digital wallet token details',
    section: DIGITAL_WALLET,
    view_only: DIGITAL_WALLET_TOKEN_DETAILS_VIEW,
    view_and_edit: DIGITAL_WALLET_TOKEN_DETAILS_VIEW_AND_EDIT,
  },
  [DISPUTES]: {
    label: 'Disputes',
    section: RISK_CONTROL,
    view_only: null,
    view_and_edit: DISPUTES_VIEW_AND_EDIT,
  },
  [PROCESS_DISPUTES]: {
    label: 'Process Disputes',
    section: RISK_CONTROL,
    view_only: null,
    view_and_edit: PROCESS_DISPUTES_VIEW_AND_EDIT,
  },
  [FULL_ACCOUNT_NUMBER]: {
    label: 'Full account number',
    section: CUSTOMERS,
    view_only: FULL_ACCOUNT_NUMBER_VIEW,
    view_and_edit: null,
  },
  [FULL_PAN]: {
    label: 'Full PAN and CVV',
    section: CARD_MANAGEMENT,
    view_only: FULL_PAN_VIEW,
    view_and_edit: null,
  },
  [INVENTORY_MGMT]: {
    label: 'Inventory Management',
    section: PROGRAM_CONTROL,
    view_only: INVENTORY_MGMT_VIEW,
    view_and_edit: null,
  },
  [INVOKE_COMMANDO_MODE]: {
    label: 'Invoke Commando Mode (stand-in processing)',
    section: CONTROL_CENTER,
    view_only: INVOKE_COMMANDO_MODE_VIEW,
    view_and_edit: INVOKE_COMMANDO_MODE_VIEW_AND_EDIT,
  },
  [KYC_EXCEPTIONS]: {
    label: 'KYC Exceptions',
    section: RISK_CONTROL,
    view_only: null,
    view_and_edit: KYC_EXCEPTIONS_VIEW_AND_EDIT,
  },
  [MANAGE_TRANSACTION_ALERTS]: {
    label: 'Transaction Review Manager',
    section: RISK_CONTROL,
    view_only: null,
    view_and_edit: MANAGE_TRANSACTION_ALERTS_VIEW_AND_EDIT,
  },
  [PRIVATE_SANDBOX]: {
    label: 'Private sandbox',
    section: CONTROL_CENTER,
    view_only: PRIVATE_SANDBOX,
    view_and_edit: null,
  },
  [PROGRAM_CONFIGURATION]: {
    label: 'Program Configuration',
    section: PROGRAM_CONTROL,
    view_only: null,
    view_and_edit: PROGRAM_CONFIGURATION_VIEW_AND_EDIT,
  },
  [ACH_PROGRAM_FUNDING]: {
    label: 'ACH program funding',
    section: CUSTOMERS,
    view_only: ACH_PROGRAM_FUNDING_VIEW,
    view_and_edit: ACH_PROGRAM_FUNDING_VIEW_AND_EDIT,
  },
  [REAL_TIME_DECISIONING]: {
    label: 'Real-time decisioning',
    section: RISK_CONTROL,
    view_only: null,
    view_and_edit: REAL_TIME_DECISIONING_VIEW_AND_EDIT,
  },
  [REPLACE_CARD]: {
    label: 'Replace card',
    section: CARD_MANAGEMENT,
    view_only: null,
    view_and_edit: REPLACE_CARD_VIEW_AND_EDIT,
  },
  [REMOVE_CARDHOLDER_FUNDS]: {
    label: 'Remove funds',
    section: CUSTOMERS,
    view_only: null,
    view_and_edit: REMOVE_CARDHOLDER_FUNDS_VIEW_AND_EDIT,
  },
  [REPORT_STOLEN]: {
    label: 'Report card lost or stolen',
    section: CARD_MANAGEMENT,
    view_only: null,
    view_and_edit: REPORT_STOLEN_VIEW_AND_EDIT,
  },
  [RETURN_DIRECT_DEPOSIT]: {
    label: 'Return direct deposit',
    section: CUSTOMERS,
    view_only: null,
    view_and_edit: RETURN_DIRECT_DEPOSIT_VIEW_AND_EDIT,
  },
  [UAM_GRANULAR_PERMISSIONS]: {
    label: 'Granular permissions',
    section: PROGRAM_CONTROL,
    view_only: UAM_GRANULAR_PERMISSIONS,
    view_and_edit: null,
  },
  [USER_DETAILS]: {
    label: 'User details',
    section: CUSTOMERS,
    view_only: USER_DETAILS_VIEW,
    view_and_edit: USER_DETAILS_VIEW_AND_EDIT,
  },
  [USER_DETAILS_SENSITIVE]: {
    label: 'User details (sensitive)',
    section: CUSTOMERS,
    view_only: USER_DETAILS_SENSITIVE_VIEW,
    view_and_edit: null,
  },
  [SET_PIN]: {
    label: 'Set PIN (sensitive)',
    section: CARD_MANAGEMENT,
    view_only: null,
    view_and_edit: SET_PIN_VIEW_AND_EDIT,
  },
  [SUSPEND_CARD]: {
    label: 'Suspend card',
    section: CARD_MANAGEMENT,
    view_only: null,
    view_and_edit: SUSPEND_CARD_VIEW_AND_EDIT,
  },
  [TRANSACTION_REVIEW_REPORT]: {
    label: 'Transaction review report',
    section: RISK_CONTROL,
    view_only: TRANSACTION_REVIEW_REPORT_VIEW,
    view_and_edit: null,
  },
  [DISPUTES_MANUAL_TRANSITIONS]: {
    label: 'Disputes Manual Transitions',
    view_only: null,
    section: RISK_CONTROL,
    view_and_edit: DISPUTES_MANUAL_TRANSITIONS_VIEW_AND_EDIT,
  },
  [CREDIT_ACCOUNT_HOLDER_DETAILS]: {
    label: 'Credit Account Holder Details',
    view_only: CREDIT_ACCOUNT_HOLDER_DETAILS_VIEW,
    section: CREDIT,
    view_and_edit: null,
  },
  [CREDIT_ACCOUNT_PAYMENT_SCHEDULE]: {
    label: 'Credit Payment Schedules',
    view_only: CREDIT_ACCOUNT_PAYMENT_SCHEDULE_VIEW,
    section: CREDIT,
    view_and_edit: null,
  },
  [CREDIT_ACCOUNT_PAYMENT_SOURCE]: {
    label: 'Credit Payment Source',
    view_only: CREDIT_ACCOUNT_PAYMENT_SOURCE_VIEW,
    section: CREDIT,
    view_and_edit: null,
  },
  [CREDIT_ACCOUNT_TRANSACTIONS]: {
    label: 'Credit Account Holder Transactions',
    view_only: CREDIT_ACCOUNT_TRANSACTIONS_VIEW,
    section: CREDIT,
    view_and_edit: CREDIT_ACCOUNT_TRANSACTIONS_VIEW_AND_EDIT,
  },
  [CREDIT_ACCOUNT_NOTES]: {
    label: 'Credit Account Holder Notes',
    view_only: CREDIT_ACCOUNT_NOTES_VIEW,
    section: CREDIT,
    view_and_edit: CREDIT_ACCOUNT_NOTES_VIEW_AND_EDIT,
  },
  [CREDIT_ACCOUNT_STATEMENTS]: {
    label: 'Credit Account Holder Statements',
    view_only: CREDIT_ACCOUNT_STATEMENTS_VIEW,
    section: CREDIT,
    view_and_edit: null,
  },
  [CREDIT_ACCOUNT_SUBSTATUS]: {
    label: 'Credit Account Holder Substatus',
    view_only: CREDIT_ACCOUNT_SUBSTATUS_VIEW,
    section: CREDIT,
    view_and_edit: CREDIT_ACCOUNT_SUBSTATUS_VIEW_AND_EDIT,
  }
};

module.exports = {
  UAM_ROLES,
  EXTERNAL_DELEGATION_REQUIRED_ROLES,
  CARD_MANAGEMENT,
  CONTROL_CENTER,
  CUSTOMERS,
  DIGITAL_WALLET,
  PROGRAM_CONTROL,
  REPORT,
  RISK_CONTROL,
  redseaRoleTokenToPermissionsHash,
  permissionsRoleTokenLabelAndRedseaHash,
  VIEW_AND_EDIT,
  VIEW_ONLY,
  NO_ACCESS,
  ACCESS_MGMT_MQ_DASHBOARD_VIEW_AND_EDIT,
  ACCESS_MGMT_MQ_DASHBOARD_VIEW,
  ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL,
  ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW,
  ACCESS_MGMT_MQ_DASHBOARD_EXTERNAL_VIEW_AND_EDIT,
  ACCESS_MGMT_MQ_DASHBOARD,
  ACCOUNT_HOLDER_DETAILS,
  ACCOUNT_HOLDER_DETAILS_SENSITIVE,
  ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW,
  ACCOUNT_HOLDER_DETAILS_SENSITIVE_VIEW_AND_EDIT,
  ACCOUNT_HOLDER_DETAILS_VIEW,
  ACCOUNT_HOLDER_DETAILS_VIEW_AND_EDIT,
  ACH_PROGRAM_FUNDING,
  ACH_PROGRAM_FUNDING_VIEW,
  ACH_PROGRAM_FUNDING_VIEW_AND_EDIT,
  AUDIT_LOGS_VIEW,
  AUDIT_LOGS,
  BIN_DATA_MANAGEMENT,
  BIN_DATA_MANAGEMENT_VIEW,
  BIN_DATA_MANAGEMENT_VIEW_AND_EDIT,
  BUSINESS_DETAILS,
  BUSINESS_DETAILS_VIEW,
  BUSINESS_DETAILS_VIEW_AND_EDIT,
  CANCEL_ACHO_PROGRAM_FUNDING,
  CANCEL_ACHO_PROGRAM_FUNDING_VIEW_AND_EDIT,
  CARD_DETAILS_VIEW_AND_EDIT,
  CARD_DETAILS_VIEW,
  CARD_DETAILS,
  CARD_PRODUCTS_VIEW,
  CARD_PRODUCTS,
  CREATE_CARD_MANUALLY_VIEW_AND_EDIT,
  CREATE_CARD_MANUALLY,
  CUSTOMER_SUPPORT_SWISSQUOTE,
  CUSTOMER_SUPPORT_YUH,
  DIGITAL_WALLET_TOKEN_DETAILS,
  DIGITAL_WALLET_TOKEN_DETAILS_VIEW,
  DIGITAL_WALLET_TOKEN_DETAILS_VIEW_AND_EDIT,
  DISPUTES,
  DISPUTES_VIEW_AND_EDIT,
  PROCESS_DISPUTES,
  PROCESS_DISPUTES_VIEW_AND_EDIT,
  FULL_ACCOUNT_NUMBER,
  FULL_ACCOUNT_NUMBER_VIEW,
  FULL_PAN_VIEW,
  FULL_PAN,
  INVENTORY_MGMT,
  INVENTORY_MGMT_VIEW,
  INVOKE_COMMANDO_MODE,
  INVOKE_COMMANDO_MODE_VIEW,
  INVOKE_COMMANDO_MODE_VIEW_AND_EDIT,
  KYC_EXCEPTIONS,
  KYC_EXCEPTIONS_VIEW_AND_EDIT,
  MANAGE_ACHO_TRANSFERS,
  MANAGE_ACHO_TRANSFERS_VIEW_AND_EDIT,
  MANAGE_TRANSACTION_ALERTS,
  MANAGE_TRANSACTION_ALERTS_VIEW_AND_EDIT,
  PRIVATE_SANDBOX,
  PROGRAM_CONFIGURATION,
  PROGRAM_CONFIGURATION_VIEW_AND_EDIT,
  REAL_TIME_DECISIONING,
  REAL_TIME_DECISIONING_VIEW_AND_EDIT,
  REPLACE_CARD_VIEW_AND_EDIT,
  REPLACE_CARD,
  REPORT_STOLEN_VIEW_AND_EDIT,
  REPORT_STOLEN,
  RETURN_DIRECT_DEPOSIT_VIEW_AND_EDIT,
  RETURN_DIRECT_DEPOSIT,
  SET_PIN,
  SET_PIN_VIEW_AND_EDIT,
  THREE_DS_SETTINGS_VIEW_AND_EDIT,
  THREE_DS_SETTINGS_VIEW,
  THREE_DS_SETTINGS,
  TRANSACTION_REVIEW_REPORT,
  TRANSACTION_REVIEW_REPORT_VIEW,
  UAM_GRANULAR_PERMISSIONS,
  USER_DETAILS_SENSITIVE_VIEW_AND_EDIT,
  USER_DETAILS_SENSITIVE_VIEW,
  USER_DETAILS_SENSITIVE,
  USER_DETAILS_VIEW_AND_EDIT,
  USER_DETAILS_VIEW,
  USER_DETAILS,
  SUSPEND_CARD,
  SUSPEND_CARD_VIEW_AND_EDIT,
  ISSUER_WRITE_OFF,
  ISSUER_WRITE_OFF_VIEW_AND_EDIT,
  REMOVE_CARDHOLDER_FUNDS,
  REMOVE_CARDHOLDER_FUNDS_VIEW_AND_EDIT,
  DISPUTES_MANUAL_TRANSITIONS,
  DISPUTES_MANUAL_TRANSITIONS_VIEW_AND_EDIT,
  CREDIT,
  CREDIT_ACCOUNT_HOLDER_DETAILS,
  CREDIT_ACCOUNT_HOLDER_DETAILS_VIEW,
  CREDIT_ACCOUNT_PAYMENT_SCHEDULE,
  CREDIT_ACCOUNT_PAYMENT_SCHEDULE_VIEW,
  CREDIT_ACCOUNT_PAYMENT_SOURCE,
  CREDIT_ACCOUNT_PAYMENT_SOURCE_VIEW,
  CREDIT_ACCOUNT_TRANSACTIONS,
  CREDIT_ACCOUNT_TRANSACTIONS_VIEW,
  CREDIT_ACCOUNT_TRANSACTIONS_VIEW_AND_EDIT,
  CREDIT_ACCOUNT_NOTES,
  CREDIT_ACCOUNT_NOTES_VIEW,
  CREDIT_ACCOUNT_NOTES_VIEW_AND_EDIT,
  CREDIT_ACCOUNT_STATEMENTS,
  CREDIT_ACCOUNT_STATEMENTS_VIEW,
  CREDIT_ACCOUNT_SUBSTATUS,
  CREDIT_ACCOUNT_SUBSTATUS_VIEW,
  CREDIT_ACCOUNT_SUBSTATUS_VIEW_AND_EDIT
};
